import { Link } from 'react-router-dom';
import { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large' | 'small';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  const sizeClasses = {
    small: 'w-[160px]',
    normal: 'w-[200px]',
    large: 'w-[240px]',
  };

  const posterHeight = {
    small: 'h-[224px]',
    normal: 'h-[280px]',
    large: 'h-[336px]',
  };

  return (
    <Link
      to={`/article/${movie.id}`}
      className={`${sizeClasses[size]} group block flex-shrink-0`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div
        className={`${posterHeight[size]} relative overflow-hidden rounded-lg mb-3`}
      >
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-transparent to-transparent" />

        {movie.isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            NEW
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-2">
            <span className="text-accent-400 text-xs font-bold whitespace-nowrap">
              <i className="ri-star-fill mr-0.5"></i>{movie.rating}
            </span>
            {movie.isHot && (
              <span className="text-accent-400 text-xs whitespace-nowrap">
                <i className="ri-fire-fill"></i> 热播
              </span>
            )}
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full">
            <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
        {movie.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 truncate">
        {movie.actors.slice(0, 2).join(' / ')}
      </p>
    </Link>
  );
}